import PlantSubServicePage from "@/components/PlantSubServicePage";

const RELATED = [
  { to: "/civil-structural", label: "Civil & Structural" },
  { to: "/electrical-instrumentation", label: "Electrical & Instrumentation" },
  { to: "/mechanical", label: "Mechanical" },
  { to: "/materials", label: "Material (MTC)" },
];

export default function Piping() {
  return (
    <PlantSubServicePage
      slug="piping"
      title="Piping"
      lead="Process design, engineering and simulation services tailored to demanding industrial environments — from FEED to detailed engineering."
      intro={[
        "At ZeroLabs, we specialize in innovative process design, engineering and simulation services across a diverse range of industries — Oil & Gas, Refining, Petrochemicals, Chemicals, Pharmaceuticals, Water Treatment, and Paper & Pulp.",
        "From Front-End Engineering Design (FEED) to detailed engineering, we offer end-to-end solutions that ensure efficiency and quality throughout every phase of your project.",
        "Our experienced team leverages cutting-edge engineering software — AVEVA, Autodesk, Hexagon, Bentley, Vertex, Revit and EZ-ISO — to deliver precision-driven results tailored to your specific needs.",
      ]}
      industries={["Oil & Gas", "Refining", "Petrochemicals", "Chemicals", "Pharmaceuticals", "Water Treatment", "Paper & Pulp"]}
      tools={["AVEVA E3D", "AVEVA PDMS", "Hexagon SmartPlant 3D", "Autodesk Plant 3D", "Bentley OpenPlant", "Vertex", "Revit", "EZ-ISO"]}
      heroImage="https://www.thantrick.com/wp-content/uploads/2025/04/34b658d354e4833dbe241d5e1732ead4-1024x768.jpg"
      gallery={[
        "https://www.thantrick.com/wp-content/uploads/elementor/thumbs/pipingDesignDarkTheme-r3yz1vjxr0ifj0nujzxz2qtmfqrqujykj0mbrs6dd8.png",
        "https://www.thantrick.com/wp-content/uploads/elementor/thumbs/Mechanical-Piping-Design-services-1-600x329-1-r3z0rxub07h044if5bq67l0agmv833cje7bhii5kj0.jpg",
        "https://www.thantrick.com/wp-content/uploads/elementor/thumbs/Piping-Engineer-scaled-1-r3yrg8rc79xfpm4odpvt7smwxnh22lnlknpqbxw8q4.webp",
      ]}
      thantrickUrl="https://thantrick.org/piping/"
      related={RELATED}
    />
  );
}
